import React from 'react'
import { Switch, Route, } from 'react-router-dom'
import {
  DistrictLicenses,
  EducatorLicenses,
  SchoolLicenses,
  SelectDistrict,
  SelectEducatorSchool,
  SelectSchool,
  SelectStudentSchool,
  StudentLicenses,
  DistrictAdminLicenses,
  SelectDistrictDA,
} from './'

export default function (props) {
  return (
    <div>
      <Switch>
        <Route path='/users/licenses/districts/:id' render={(newProps) => <DistrictLicenses {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/districts' render={(newProps) => <SelectDistrict {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/schools/:id' render={(newProps) => <SchoolLicenses {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/schools' render={(newProps) => <SelectSchool {...{ ...props, ...newProps }} />}/>   
        <Route path='/users/licenses/district-admins/:id' render={(newProps) => <DistrictAdminLicenses {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/district-admins' render={(newProps) => <SelectDistrictDA {...{ ...props, ...newProps }} />}/>      
        <Route path='/users/licenses/educators/:id' render={(newProps) => <EducatorLicenses {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/educators' render={(newProps) => <SelectEducatorSchool {...{ ...props, ...newProps }} />}/> 
        <Route path='/users/licenses/students/:id' render={(newProps) => <StudentLicenses {...{ ...props, ...newProps }} />}/>
        <Route path='/users/licenses/students' render={(newProps) => <SelectStudentSchool {...{ ...props, ...newProps }} />}/>           
      </Switch>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Users/Licenses/LicensesCardRouter.js